/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const AlertBellArrow = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 54 56" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M2 32.43a1.33 1.33 0 0 0-1.63.94 10.07 10.07 0 0 0 7.21 12.4 1.31 1.31 0 0 0 1-.13 1.36 1.36 0 0 0 .62-.8 1.32 1.32 0 0 0-.94-1.62 7.46 7.46 0 0 1-5.33-9.17A1.32 1.32 0 0 0 2 32.43z" /><path d="M40.5 6A13.5 13.5 0 1 0 54 19.5 13.49 13.49 0 0 0 40.5 6zm0 20.76a7.08 7.08 0 0 1-7-7.22 7.07 7.07 0 0 1 7-7.21 7.72 7.72 0 0 1 4.84 1.72V12.9a.91.91 0 0 1 .9-.9.8.8 0 0 1 .82.9v4.27h-4.1a.91.91 0 0 1 0-1.81h1a5.59 5.59 0 0 0-3.44-1.15 5.33 5.33 0 0 0 0 10.66 5.18 5.18 0 0 0 5.08-4.4h1.83a7 7 0 0 1-6.96 6.29z" fill={secondaryColor} /><path d="M15.69 10.09a4 4 0 1 0-5.46-1.45 4 4 0 0 0 5.46 1.45z" /><path d="M49.47 31.92A15.49 15.49 0 0 1 47 33.33c1.2 1.05 2.26 1.94 3.06 2.6l-29 16.65c-.7-4.14-2.63-13.95-5.84-19.47l-2.65-4.57A11.87 11.87 0 0 1 17 12.3a12.08 12.08 0 0 1 10.21-.85 15.14 15.14 0 0 1 1.61-2.2 14.73 14.73 0 0 0-8.74-.88 6.53 6.53 0 0 0-.62-5.09A6.68 6.68 0 0 0 10.39.89 6.56 6.56 0 0 0 12 13a14.44 14.44 0 0 0-1.77 16.88l2.65 4.56c3.8 6.55 5.8 20.3 5.82 20.44a1.31 1.31 0 0 0 .73 1 1.35 1.35 0 0 0 1.25 0l10.41-6 .7 1.12a6.68 6.68 0 0 0 9.1 2.39 6.6 6.6 0 0 0 2.46-9l-.66-1.14 10.4-6a1.31 1.31 0 0 0 .17-2.18s-1.63-1.27-3.79-3.15zM10.23 8.59a4 4 0 0 1 1.48-5.42 4 4 0 0 1 5.46 1.44A4 4 0 0 1 15.69 10a4 4 0 0 1-5.46-1.41zM39.56 51.1a4 4 0 0 1-5.46-1.43l-.66-1.14 6.94-4 .62 1.16a4 4 0 0 1-1.44 5.41z" />
      </g>
    </svg>
  </span>
);

AlertBellArrow.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

AlertBellArrow.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default AlertBellArrow;
